/**
 * @packageDocumentation
 * @module f1/is
 */

export interface IsNan {
  /**
   * Is the value "not a number" or NaN, uses `Number.isNan`
   *
   * @public
   * @function f1.is.nan
   * @example
   *
   * ```ts
   * f1.is.nan(NaN) => true
   * f1.is.nan(1) => false
   * ```
   */
  (value: unknown): boolean;
}

/**
 * @see IsNan
 */
export default (value: unknown): boolean => {
  return Number.isNaN(value);
};
